jQuery(function($) {
  gsap.matchMedia().add({
    isDesktop: `(min-width: 768.02px)`,
    isMobile: `(max-width: 768px)`,
  },
  (context) => {
    let {isDesktop, isMobile} = context.conditions;
    let navbar_shrink = false

    if (isDesktop) {
      let navbarTl = gsap.timeline({
        paused: true,
      })
      .fromTo('nav.navbar', {
        width: '100%',
      }, {
        width: 'auto',
        duration: 1,
        ease: 'power2.out',
      })
      .fromTo('nav.navbar', {
        backgroundColor: 'transparent',
      }, {
        backgroundColor: '#fcf9f7cf',
        duration: 1,
        ease: 'power2.out',
      }, '>-.8')
      .fromTo('nav.navbar .link.home', {
        opacity: 0,
      }, {
        opacity: 1,
        duration: .6,
        ease: 'power2.out',
      }, '>-1')

      const handleNavbarScroll = function() {
        if (!navbar_shrink && window.scrollY > 1) {
          navbar_shrink = true

          jQuery('.navbar').addClass('shrink')

          navbarTl.play()
        }
        else if (navbar_shrink && window.scrollY <= 1) {
          navbar_shrink = false

          jQuery('.navbar').removeClass('shrink')

          navbarTl.reverse()
        }
      }

      handleNavbarScroll()
      window.addEventListener('scroll', handleNavbarScroll)
    }
    
  })
})